module.exports = "  <form [formGroup]=\"form\">\r\n    <div *ngFor=\"let question of questions\" class=\"form-row\">\r\n      <df-question [question]=\"question\" [form]=\"form\"></df-question>\r\n    </div>\r\n  </form>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-dynamic-form/dynamic-form.component.html
// module id = ../../../../../src/app/shared/cui-dynamic-form/dynamic-form.component.html
// module chunks = main